import angular from 'angular';
import providerInfo from './providerInfo';
import './style.scss';

export default angular
  .module('components.providerInfo', [])
  .component('providerInfo', providerInfo).name;
